import React from "react";

const TextInputMinimal = ({
  input: { name, onChange, value, type },
  tabIndex,
  placeholder,
  required,
  autoComplete,
  className,
  id,
  onKeyUp = () => {}
}) => (
  <input
    id={id}
    tabIndex={tabIndex}
    className={className}
    name={name}
    value={value}
    onChange={onChange}
    onKeyUp={onKeyUp}
    type={type || "text"}
    placeholder={placeholder}
    required={required}
    autoComplete={autoComplete || "off"}
  />
);

export default TextInputMinimal;
